import { replaceCurrentRoute } from "./utils.js";
var RoutingError = /* @__PURE__ */ ((RoutingError2) => {
  RoutingError2["MISSING_STORE_ID"] = "MISSING_STORE_ID";
  RoutingError2["ALTERNATIVE_URL_STORE"] = "ALTERNATIVE_URL_STORE";
  RoutingError2["STORE_NOT_FOUND"] = "STORE_NOT_FOUND";
  RoutingError2["LINKED_APPOINTMENT_TYPE_NOT_VALID"] = "LINKED_APPOINTMENT_TYPE_NOT_VALID";
  RoutingError2["ALTERNATIVE_LINKED_APPOINTMENT_TYPE_NOT_VALID"] = "ALTERNATIVE_LINKED_APPOINTMENT_TYPE_NOT_VALID";
  RoutingError2["MISSING_TYPE_ID"] = "MISSING_TYPE_ID";
  RoutingError2["TYPE_NOT_FOUND"] = "TYPE_NOT_FOUND";
  RoutingError2["TYPE_NOT_AVAILABLE_FOR_STORE"] = "TYPE_NOT_AVAILABLE_FOR_STORE";
  RoutingError2["INVALID_VIRTUAL_APPOINTMENT"] = "INVALID_VIRTUAL_APPOINTMENT";
  RoutingError2["MISSING_TIMESLOT_START"] = "MISSING_TIMESLOT_START";
  RoutingError2["MISSING_TIMESLOT_END"] = "MISSING_TIMESLOT_END";
  RoutingError2["MISSING_APPOINTMENT_ID"] = "MISSING_APPOINTMENT_ID";
  return RoutingError2;
})(RoutingError || {});
const MissingStoreIdError = () => new Error(
  "MISSING_STORE_ID"
  /* MISSING_STORE_ID */
);
const AlternativeUrlStoreError = () => new Error(
  "ALTERNATIVE_URL_STORE"
  /* ALTERNATIVE_URL_STORE */
);
const StoreNotFoundError = () => new Error(
  "STORE_NOT_FOUND"
  /* STORE_NOT_FOUND */
);
const MissingTypeIdError = () => new Error(
  "MISSING_TYPE_ID"
  /* MISSING_TYPE_ID */
);
const TypeNotFoundError = () => new Error(
  "TYPE_NOT_FOUND"
  /* TYPE_NOT_FOUND */
);
const TypeNotAvailableForStoreError = () => new Error(
  "TYPE_NOT_AVAILABLE_FOR_STORE"
  /* TYPE_NOT_AVAILABLE_FOR_STORE */
);
const LinkedAppointmentTypeNotValidError = () => new Error(
  "LINKED_APPOINTMENT_TYPE_NOT_VALID"
  /* LINKED_APPOINTMENT_TYPE_NOT_VALID */
);
const AlternativeLinkedAppointmentTypeNotValidError = () => new Error(
  "ALTERNATIVE_LINKED_APPOINTMENT_TYPE_NOT_VALID"
  /* ALTERNATIVE_LINKED_APPOINTMENT_TYPE_NOT_VALID */
);
const InvalidVirtualAppointmentError = () => new Error(
  "INVALID_VIRTUAL_APPOINTMENT"
  /* INVALID_VIRTUAL_APPOINTMENT */
);
const MissingTimeSlotStartError = () => new Error(
  "MISSING_TIMESLOT_START"
  /* MISSING_TIMESLOT_START */
);
const MissingTimeSlotEndError = () => new Error(
  "MISSING_TIMESLOT_END"
  /* MISSING_TIMESLOT_END */
);
const MissingAppointmentIdError = () => new Error(
  "MISSING_APPOINTMENT_ID"
  /* MISSING_APPOINTMENT_ID */
);
const routingErrorHandler = (errorMessage, selfUrl, asPath, currentRoute, queryParams) => {
  switch (errorMessage) {
    case "STORE_NOT_FOUND":
    case "ALTERNATIVE_URL_STORE":
      delete queryParams.storeId;
    case "MISSING_STORE_ID":
      return {
        type: "redirect",
        url: replaceCurrentRoute(selfUrl, asPath, currentRoute, "", queryParams)
      };
    case "TYPE_NOT_AVAILABLE_FOR_STORE":
      if (currentRoute === "" || currentRoute === "where") {
        delete queryParams.storeId;
      } else {
        delete queryParams.typeId;
      }
      return {
        type: "redirect",
        url: replaceCurrentRoute(
          selfUrl,
          asPath,
          currentRoute,
          ["", "where"].includes(currentRoute) ? currentRoute : "what",
          queryParams
        )
      };
    case "LINKED_APPOINTMENT_TYPE_NOT_VALID":
      delete queryParams.linkedAppointmentTypeId;
      return {
        type: "redirect",
        url: replaceCurrentRoute(selfUrl, asPath, currentRoute, currentRoute, queryParams)
      };
    case "ALTERNATIVE_LINKED_APPOINTMENT_TYPE_NOT_VALID":
      delete queryParams.alternativeLinkedAppointmentTypeId;
      return {
        type: "redirect",
        url: replaceCurrentRoute(selfUrl, asPath, currentRoute, currentRoute, queryParams)
      };
    case "TYPE_NOT_FOUND":
      delete queryParams.typeId;
      return {
        type: "redirect",
        url: replaceCurrentRoute(
          selfUrl,
          asPath,
          currentRoute,
          ["", "where"].includes(currentRoute) ? currentRoute : "what",
          queryParams
        )
      };
    case "MISSING_TYPE_ID":
      return {
        type: "redirect",
        url: replaceCurrentRoute(selfUrl, asPath, currentRoute, "what", queryParams)
      };
    case "INVALID_VIRTUAL_APPOINTMENT":
      delete queryParams.storeId;
      delete queryParams.typeId;
      return {
        type: "redirect",
        url: replaceCurrentRoute(selfUrl, asPath, currentRoute, "", queryParams)
      };
    case "MISSING_TIMESLOT_START":
    case "MISSING_TIMESLOT_END":
      delete queryParams.start;
      delete queryParams.end;
      return {
        type: "redirect",
        url: replaceCurrentRoute(selfUrl, asPath, currentRoute, "when", queryParams)
      };
    case "MISSING_APPOINTMENT_ID":
      return {
        type: "redirect",
        url: replaceCurrentRoute(selfUrl, asPath, currentRoute, "who", queryParams)
      };
    default:
      return {
        type: "not-found"
      };
  }
};
export {
  AlternativeLinkedAppointmentTypeNotValidError,
  AlternativeUrlStoreError,
  InvalidVirtualAppointmentError,
  LinkedAppointmentTypeNotValidError,
  MissingAppointmentIdError,
  MissingStoreIdError,
  MissingTimeSlotEndError,
  MissingTimeSlotStartError,
  MissingTypeIdError,
  RoutingError,
  StoreNotFoundError,
  TypeNotAvailableForStoreError,
  TypeNotFoundError,
  routingErrorHandler
};
//# sourceMappingURL=errors.js.map
